@if (temConteudo()) {
    @if (foto(); as retrato) {
        <!-- Com foto o retrato é clicável e abre o preview do PrimeNG (zoom e rotação) — o mesmo
             comportamento da coluna `perfil` da tabela e da tela de biometria. `appendTo="body"`
             porque o overlay nasceria dentro do card, que tem recorte. -->
        <p-image [src]="retrato" alt="" [preview]="true" [appendTo]="'body'" data-foto="retrato" styleClass="foto-diretor-imagem foto-diretor-imagem--clicavel" />
    } @else {
        <!-- Iniciais seguem inertes: sem foto não há detalhe a ampliar. -->
        <span class="foto-diretor-imagem foto-diretor-imagem--iniciais" data-foto="iniciais">{{ iniciais() }}</span>
    }
}
